import React, { useContext, useLayoutEffect, useState } from "react";
import { Chatbot } from "./sections/chatbot";
import PortableText from "./portableText";
import { SectionWrapper } from "./sections";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRobot } from "@fortawesome/free-solid-svg-icons";
import { toPlainText } from "../lib/helpers";
import { SiteContext } from "./global/site-context";
import { fas as iconSet } from "@fortawesome/free-solid-svg-icons";
import { EyebrowPill } from "./serializers";
import tailwindConfig from "../../tailwind.config";

// Simple array of field keys and labels
const FIELDS = [
  { key: "role", label: "Role", string: true, field: "role" },
  { key: "tasks", label: "Task / Overall Goal(s)", string: true, field: "tasks" },
  // { key: "_rawAnswers", label: "How to Answer", field: "_rawAnswers" },
  // { key: "_rawInterject", label: "Interjections", field: "_rawInterject" },
];

const DEFAULT_ROLE = "support engineer";

export const AgentPage = (props) => {
  const {
    _id,
    title,
    _rawExcerpt,
    role,
    tasks,
    _rawInterject,
    _rawAnswers,
    steps,
    questions,
    copilotID,
    workflowID,
    icon = "faRobot",
  } = props;
  const site = useContext(SiteContext);
  const storage = site.metrics.analytics.storage;
  const isRoomie = !!storage.getItem("roomie");

  const [promptAnswer, setPromptAnswer] = useState(toPlainText(_rawAnswers));
  const [promptInterject, setPromptInterject] = useState(toPlainText(_rawInterject));

  useLayoutEffect(() => {
    if (!window) return;
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("roomie")) {
      storage.setItem("roomie", true);
    }
  }, []);

  return (
    <SectionWrapper container="thin">
      <div className="lg:max-w-3/4 mt-4 mb-12 text-center mx-auto">
        <EyebrowPill isSpecial={true}>
          <h1 className="flex items-center justify-center gap-2 font-medium md:text-lg">
            <FontAwesomeIcon
              icon={iconSet[icon] || faRobot}
              className="relative -top-px max-h-8"
              size="lg"
            />
            {title}
          </h1>
        </EyebrowPill>
        <h2 className="text-3xl lg:text-5xl mx-auto">
          <PortableText blocks={_rawExcerpt} />
        </h2>
      </div>

      <Chatbot
        copilotID={copilotID}
        workflowID={workflowID}
        agentPage={true}
        agent={{
          _id,
          role: role || DEFAULT_ROLE,
          tasks,
          title,
          interject: promptInterject,
          answers: promptAnswer,
          questions: questions,
          steps: steps
            ? steps.map(s => ({
              goal: s.goal,
              smarts: s.smarts,
              response: toPlainText(s._rawResponse),
              achievement: s.achievement
            }))
            : []
        }}
      />

      {isRoomie && (
        <div className="pt-12 text-dark-60 hover:text-black transition-colors duration-300">
          <div className="mb-8">
            <div className="bg-light-60 rounded-xl p-4 shadow-lg">
              {FIELDS.map(({ key, label, string }) => (
                <div className="mb-4" key={key}>
                  <h3 className="font-semibold mb-1">{label}</h3>
                  {string ? (
                    <pre className="font-mono text-sm p-2 pl-0 whitespace-pre-wrap leading-normal">
                      {props[key] || "No data available"}
                    </pre>
                  ) : (
                    <pre className="font-mono text-sm p-2 whitespace-pre-wrap leading-normal">
                      <PortableText blocks={props[key] || []} />
                    </pre>
                  )}
                </div>
              ))}

              <form className="mb-4">
                <h3 className="font-semibold mb-1">Interjections</h3>
                <textarea
                  value={promptInterject}
                  onChange={(e) => setPromptInterject(e.target.value)}
                  className="font-mono border border-dark-20 rounded-lg text-sm bg-white p-4 rounded-lg whitespace-pre-wrap leading-normal w-full"
                  rows={12}
                />
              </form>

              <form className="mb-4">
                <h3 className="font-semibold mb-1">How to Answer</h3>
                <textarea
                  value={promptAnswer}
                  onChange={(e) => setPromptAnswer(e.target.value)}
                  className="font-mono border border-dark-20 rounded-lg text-sm bg-white p-4 rounded-lg whitespace-pre-wrap leading-normal w-full"
                  rows={12}
                />
              </form>

              {steps && steps?.length > 0 && (
                <div>
                  <h3 className="font-semibold mb-1">
                    Conversation Steps
                  </h3>
                  <ol className="list-decimal pl-9 font-mono text-sm bg-white p-2 rounded-md whitespace-pre-wrap leading-normal">
                    {steps.map((step, index) => (
                      <li key={index} className="mb-2">
                        <span>{step.goal}</span>
                        {/* {step._rawResponse && (
                        <div className="text-sm text-dark-70 mt-1">
                          <PortableText blocks={step._rawResponse} />
                        </div>
                      )}
                      {step.smarts && step.smarts !== "normal" && (
                        <span
                          className={cn(
                            "inline-block text-xs px-2 py-1 rounded-md whitespace-pre-wrap leading-normal"> ml-2",
                            step.smarts === "basic"
                              ? "bg-yellow-100 text-yellow-800"
                              : "bg-blue-100 text-blue-800"
                          )}
                        >
                          {step.smarts === "basic" ? "Basic" : "Genius"}
                        </span>
                      )} */}
                      </li>
                    ))}
                  </ol>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </SectionWrapper>
  )
};
